import { render, staticRenderFns } from "./OpinionsDemo.vue?vue&type=template&id=5097a005&scoped=true&"
import script from "./OpinionsDemo.vue?vue&type=script&lang=js&"
export * from "./OpinionsDemo.vue?vue&type=script&lang=js&"
import style0 from "./OpinionsDemo.vue?vue&type=style&index=0&id=5097a005&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5097a005",
  null
  
)

export default component.exports